"use client";

import { useEffect } from "react";

export default function ChunkGuard() {
  useEffect(() => {
    const isChunkErr = (err: any) => {
      const name = err?.name || err?.reason?.name;
      const msg = String(err?.message || err?.reason?.message || "");
      return (
        name === "ChunkLoadError" ||
        /ChunkLoadError/i.test(msg) ||
        /Loading chunk .* failed/i.test(msg)
      );
    };

    const onRejection = (e: PromiseRejectionEvent) => {
      if (isChunkErr(e.reason)) {
        e.preventDefault?.();
        window.location.reload();
      }
    };
    const onError = (e: ErrorEvent) => {
      const err = e.error || e;
      if (isChunkErr(err)) {
        e.preventDefault?.();
        window.location.reload();
      }
    };

    window.addEventListener("unhandledrejection", onRejection);
    window.addEventListener("error", onError);
    return () => {
      window.removeEventListener("unhandledrejection", onRejection);
      window.removeEventListener("error", onError);
    };
  }, []);

  return null;
}
